import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-policy-yuri-list';
const html = `
<div data-show-title="true" data-attribute="card-title" class="title-card">

</div>
<div data-attribute="list-item" class="list-item" data-background-icon="#cb6387" style="--background-icon: #cb6387;">
  <div data-attribute="item" class="wrap-item">
    <div class="icon-left">
      <img data-attribute="icon-item"
        src="https://cdn.skyfastimg.com/images/2026/04/28/image-69f09a839afa141ca61a1f03.webp" alt="">
    </div>
    <div data-attribute="text-item" class="text-right-item">
      <p>60-Day Money Back Guarantee Didn't work for you? Contact us within 60 days for a full refund! No questions
        asked.</p>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
});
